export enum FailureEventType {
  Block = 'Block',
  FailedAttempt = 'Failed Attempt',
  Reactivation = 'Reactivation',
  EmailAlert = 'Email Alert',
}

export interface PaymentFailureAuditLog {
  userId: string;
  email: string;
  eventType: FailureEventType;
  adminEmail?: string;
  alertEmailSentTo?: string;
}
